import { render, staticRenderFns } from "./CockpitMatryoshkaItemContentsTab.vue?vue&type=template&id=6eb7f786&scoped=true"
import script from "./CockpitMatryoshkaItemContentsTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemContentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb7f786",
  null
  
)

export default component.exports